import React, { useState } from 'react'

import {
  StyleSheet,
  View,
  Text,
} from 'react-native'

import {
  adaptive, typography
} from '@sart/styles'

import { useContent } from '@sart/content'
import { HorizontalLine, Space, CallHistoryItem } from '@sart/components'
import { colors } from '@sart/styles'

export default function CallHistory(props) {
  // const { navigation } = props
  const content = useContent()

  return (
    <View style={styles.container}>
        <Space height={12} />
        <CallHistoryItem lineColor={colors.srGreen} missedCall={false} />
        <Space height={8} />
        <CallHistoryItem lineColor={colors.srGreen} missedCall={false} />
        <Space height={8} />
        <CallHistoryItem lineColor={colors.srGreen} missedCall={true} />
        <Space height={8} />
        <CallHistoryItem lineColor={colors.srGreen} missedCall={false} />
        <Space height={8} />
    </View>
  )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 25,
        ...adaptive.wrapperPadding
    },
})
